import { memo } from 'react';
import { ClothTypeDef } from '@api/types/ClothTypeDef';



interface PatternItemProps {
	item: ClothTypeDef,
	onClick: (id: number) => void,
	isSelected: boolean,
	notSelected: boolean,
}


const PatternItem = (props: PatternItemProps) => {
	const { onClick, isSelected, notSelected } = props;
	const { id, base64 } = props.item;

	if (!base64 || base64.length === 0) return (
		<div className={`pattern-item placeholder${notSelected ? ' not-active-item' : ''}${isSelected ? ' active-item' : ''}`}
			onClick={() => onClick(id)}>
		</div>
	)

	return (
		<div className={`pattern-item disable-selection${notSelected ? ' not-active-item' : ''}${isSelected ? ' active-item' : ''}`}
			onClick={() => onClick(id)}>
			
			<img src={`data:image/jpeg;base64,${base64}`} alt='pattern-item' draggable={false} id={`pattern-item-id:${id}`}/>	

		</div>
	);
}

export default memo(PatternItem);